import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Lifestyle from "@/components/site/Lifestyle";
import WhyItExists from "@/components/site/WhyItExists";
import LaunchEditions from "@/components/site/LaunchEditions";
import ClubEditions from "@/components/site/ClubEditions";
import ScenicEditions from "@/components/site/ScenicEditions";
import PrivateClub from "@/components/site/PrivateClub";
import Collections from "@/components/site/Collections";
import Waitlist from "@/components/site/Waitlist";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <main
        id="main-content"
        tabIndex={-1}
        className="bg-[#14201a] text-[#f7f4ec] min-h-screen"
      >
        <Nav />
        <Hero />
        <Lifestyle />
        <WhyItExists />
        <LaunchEditions />
        <ClubEditions />
        <ScenicEditions />
        <PrivateClub />
        <Collections />
        <Waitlist />
        <Footer />
      </main>
    </>
  );
}
